<template>
    <el-dialog
        ref="DialogMachine"
        v-model="visibled"
        :title="title"
        width="500"
        align-center
        draggable
        @closed="onClosed"
        @keyup.enter="doConfirm">
        <el-form
            ref="RuleFormRef"
            :model="data"
            :rules="rules"
            :hide-required-asterisk="true"
            :inline-message="true">
            <el-form-item label="编码" prop="code">
                <el-input
                    v-model="data.code"
                    autocomplete="off"
                    placeholder="必填项"
                    clearable
                    maxlength="32" />
            </el-form-item>
            <el-form-item label="名称" prop="name">
                <el-input
                    v-model="data.name"
                    autocomplete="off"
                    placeholder="必填项"
                    clearable
                    maxlength="32" />
            </el-form-item>
            <el-form-item label="设备" prop="device">
                <el-input
                    v-model="data.device"
                    autocomplete="off"
                    placeholder="必填项"
                    clearable
                    maxlength="32" />
            </el-form-item>
            <el-form-item v-if="!is_new" label="状态" prop="active">
                <el-select
                    v-model="data.state"
                    placeholder="必填项">
                    <el-option label="活跃" value="1" />
                    <el-option label="冻结" value="0" />
                </el-select>
            </el-form-item>
        </el-form>
        <div class="foot_div">
            <el-row>
                <el-col :span="4" />
                <el-col :span="6">
                    <el-button
                        class="btn_button"
                        @click="visibled = false">
                        取消
                    </el-button>
                </el-col>
                <el-col :span="4" />
                <el-col :span="6">
                    <el-button
                        class="btn_button"
                        :disabled="!validate"
                        type="primary"
                        @click="doConfirm">
                        保存
                    </el-button>
                </el-col>
                <el-col :span="4" />
            </el-row>
        </div>
    </el-dialog>
</template>

<script>
import {watch, ref} from 'vue';
import {notify, dict, asleep} from '../../assets/js/utils.js';
export default {
    name: 'DialogMachine',
    components: {
    },
    props: {
    },
    setup() {
        const data = ref({});
        return {data};
    },
    data() {
        return {
            visibled: false,
            resolve: null,
            reject: null,
            title: null,
            list: [],
            validate: false,
        };
    },
    computed: {
        // validate() {
        //     return Object.entries(this.get_changed_fields()).length > 0;
        // },
        is_new() {
            console.log(`is new ${!this.options.data.id}`);
            return !this.data.id;
        },
        rules() {
            // 重复检测
            const validate_duplicate = (rule, value, callback) => {
                const key = rule.field;
                if (this.list.some(x => x[key] === value && x.id !== parseInt(this.data.id))) {
                    callback(new Error(rule.message ?? `${rule.field} was duplicate.`));
                } else {
                    callback();
                }
            };
            // 字段检测规则;
            const rules = {
                name: [
                    {required: true, message: '请输入', trigger: ['change', 'blur']},
                    {
                        validator: validate_duplicate,
                        message: '名称',
                        trigger: ['change', 'blur'],
                    }],
                code: [
                    {required: true, message: '请输入', trigger: ['change', 'blur']},
                    {
                        validator: validate_duplicate,
                        message: '编码',
                        trigger: ['change', 'blur'],
                    },
                ],
                device: [
                    {required: true, message: '请输入', trigger: ['change', 'blur']},
                    {validator: validate_duplicate, message: '设备', trigger: ['change', 'blur']},
                ],
            };

            const rule_fields = {
                true: ['code', 'name', 'device'],
                false: ['code', 'name', 'device'],
            };
            return rule_fields[this.is_new].reduce((rs, k) => {
                rs[k] = rules[k];
                return rs;
            }, {});
        },
    },
    mounted() {
        watch(this.data, () => {
            this.validate = Object.entries(this.get_changed_fields()).length > 0;
        }, {deep: true});
    },
    methods: {
        async show(options) {
            console.debug(options);
            this.options = options;
            this.visibled = true;
            this.title = options.title ?? options.data.id ? '修改' : '添加';
            this.list = options.list;
            Object.entries(this.data).forEach(([k, _]) => delete (this.data[k]));
            Object.entries(options.data).forEach(([k, v]) => {
                this.data[k] = ['number', 'boolean'].indexOf(typeof v) >= 0 ? `${v}` : v;
            });
            this.data.password = null;
            (async () => {
                await asleep(100);
                this.$refs.RuleFormRef?.clearValidate();
            })();
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        get_changed_fields() {
            const form = this.$refs.RuleFormRef;
            if (!form) return false;
            // 获取要提交的数据
            const fields = form.fields.map(x => x.prop);
            console.log('fields:', fields);
            const empty = ['', null, undefined];
            const newdata = {
                ...dict(Object.entries(this.data)
                    .filter(([k, v]) => empty.indexOf(v) < 0 && fields.indexOf(k) >= 0)),
                ...{state: parseInt(this.data.state)},
            };
            const olddata = {...this.options.data};
            // console.log('OLD:', olddata);
            // console.log('NEW:', newdata);
            const data = (() => {
                // 添加不需要过滤
                if (!olddata.id) return newdata;
                // 修改过滤未修改参数
                return dict(Object.entries(newdata).filter(([k, v]) => Array.isArray(v)
                    ? JSON.stringify(olddata[k].sort()) !== JSON.stringify(v.sort())
                    : olddata[k] !== v));
            })();
            return data;
        },

        async doConfirm() {
            const form = this.$refs.RuleFormRef;
            try {
                await form.validate();
            } catch (e) {
                console.warn(e);
                notify('error', '填写错误！');
                return;
            }
            const data = this.get_changed_fields();
            if (Object.entries(data).length) {
                console.debug('submit data:', data);
                try {
                    const res = await this.axios.post(
                        `/api/machines/${this.data.id || ''}`,
                        {...data, id: this.data.id},
                        {headers: {'Content-Type': 'application/json'}},
                    );
                    if (res.data.error) {
                        notify('error', `${res.data.error} ${res.data?.message}`);
                        return;
                    }
                } catch (e) {
                    notify(e);
                    console.error(e);
                    return;
                }
                this.resolve(data);
                this.reject = null;
                this.visibled = false;
                notify('success', '提交成功！', 999);
            } else {
                notify('warning', '无字段变化！');
            }
        },
        onClosed() {
            if (this.reject) {
                this.reject();
            }
        },
    },
};
</script>

<style>

</style>
